<wl-mijn-information-block
  [customerStatus]="customerStatus$ | async"
  [rendering]="rendering"
  wlCSCapture
></wl-mijn-information-block>
